import { Directive, ElementRef, inject, afterNextRender, Input } from '@angular/core';

@Directive({
  selector: '[appAnimateOnScroll]',
  standalone: true
})
export class AnimateOnScrollDirective {
  private elementRef = inject(ElementRef);
  
  // Predvolené triedy pre počiatočný stav (skryté a posunuté dole)
  @Input() startClass = 'opacity-0 translate-y-12';
  // Predvolené triedy pre koncový stav (viditeľné a na mieste)
  @Input() endClass = 'opacity-100 translate-y-0';
  // Oneskorenie animácie v ms
  @Input() delay = 0;

  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Pridanie oneskorenia ak je nastavené
            setTimeout(() => {
                const el = this.elementRef.nativeElement;
                // Odstránime počiatočné triedy
                this.startClass.split(' ').forEach(c => el.classList.remove(c));
                // Pridáme koncové triedy
                this.endClass.split(' ').forEach(c => el.classList.add(c));
                
                observer.unobserve(entry.target);
            }, this.delay);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

      // Nastavenie počiatočných štýlov
      const el = this.elementRef.nativeElement;
      el.classList.add('transition-all', 'duration-1000', 'ease-out');
      this.startClass.split(' ').forEach(c => el.classList.add(c));
      
      observer.observe(el);
    });
  }
}